import { render, staticRenderFns } from "./BackofficeSuprimentos.vue?vue&type=template&id=a71d00b2&scoped=true"
import script from "./BackofficeSuprimentos.vue?vue&type=script&lang=ts"
export * from "./BackofficeSuprimentos.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeSuprimentos.vue?vue&type=style&index=0&id=a71d00b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71d00b2",
  null
  
)

export default component.exports